module.exports = __webpack_public_path__ + "media/images/ticket/set_order-0b6d2e1bada5f3e4a4225f40568ae52a.png";